import {IInsurance} from "@/model/Insurance/Insurance"

export interface IHasInsurancesIncluded {
    getInsurancesIncluded(): IInsurance[]
    getInsurancesIncludedMap(): Map<string, IInsurance>
    addInsuranceIncluded(insurance: IInsurance): void
    removeInsuranceIncluded(insurance: IInsurance): void
}

function hasInsurancesIncluded<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsurancesIncluded {
        private insurancesIncluded: IInsurance[] = []
        private insurancesIncludedMap: Map<string, IInsurance> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsurancesIncluded(): IInsurance[] {
            return this.insurancesIncluded
        }
        public getInsurancesIncludedMap(): Map<string, IInsurance> {
            return this.insurancesIncludedMap
        }
        public addInsuranceIncluded(insurance: IInsurance): void {
            if (this.insurancesIncludedMap.has(insurance.getIdFull())) return
            this.insurancesIncluded.push(insurance)
            this.insurancesIncludedMap.set(insurance.getIdFull(), insurance)
        }
        public removeInsuranceIncluded(insurance: IInsurance): void {
            if (!this.insurancesIncludedMap.has(insurance.getIdFull())) return
            this.insurancesIncluded = this.insurancesIncluded.filter((existingInsurance: IInsurance) => existingInsurance.getIdFull() !== insurance.getIdFull())
            this.insurancesIncludedMap.delete(insurance.getIdFull())
        }
    };
}

export default hasInsurancesIncluded